import { useState } from "react";
import { Instagram, Mail, Loader2, Send } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";

const IG = "barbarauwadiee";
const EMAIL = "hello@unfilteredbybarbarauwadie.com";

export default function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success(t("send") + " ✓");
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Errore"); } finally { setBusy(false); }
  };

  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow={t("nav_contact")} title={t("contact_title")} desc={t("contact_desc")} />
      <div className="max-w-[1100px] mx-auto px-4 sm:px-8 lg:px-16 pb-24 grid md:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16">
        <div className="space-y-6">
          <a href={`mailto:${EMAIL}`} data-testid="contact-email"
            className="flex items-center gap-4 group">
            <span className="w-11 h-11 rounded-full border border-[rgba(198,137,158,0.3)] flex items-center justify-center group-hover:bg-[#C6899E] transition-colors">
              <Mail className="w-5 h-5 text-[#C6899E] group-hover:text-[#4A2233] transition-colors" />
            </span>
            <span className="text-[#8C7E83] group-hover:text-[#3D3238] transition-colors break-all">{EMAIL}</span>
          </a>
          <a href={`https://instagram.com/${IG}`} target="_blank" rel="noreferrer" data-testid="contact-instagram"
            className="flex items-center gap-4 group">
            <span className="w-11 h-11 rounded-full border border-[rgba(198,137,158,0.3)] flex items-center justify-center group-hover:bg-[#C6899E] transition-colors">
              <Instagram className="w-5 h-5 text-[#C6899E] group-hover:text-[#4A2233] transition-colors" />
            </span>
            <span className="text-[#8C7E83] group-hover:text-[#3D3238] transition-colors">@{IG}</span>
          </a>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] text-[#9C8F94] mb-2">{t("name")}</label>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              data-testid="contact-name"
              className="w-full bg-[#FFFFFF] border border-[rgba(61,50,56,0.1)] rounded-xl px-4 py-3 text-[#3D3238] focus:border-[#C6899E] focus:outline-none transition-colors" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] text-[#9C8F94] mb-2">{t("email")}</label>
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="contact-email-input"
              className="w-full bg-[#FFFFFF] border border-[rgba(61,50,56,0.1)] rounded-xl px-4 py-3 text-[#3D3238] focus:border-[#C6899E] focus:outline-none transition-colors" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] text-[#9C8F94] mb-2">{t("message")}</label>
            <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              data-testid="contact-message"
              className="w-full bg-[#FFFFFF] border border-[rgba(61,50,56,0.1)] rounded-xl px-4 py-3 text-[#3D3238] focus:border-[#C6899E] focus:outline-none transition-colors resize-none" />
          </div>
          <button type="submit" disabled={busy} data-testid="contact-submit"
            className="inline-flex items-center gap-2 bg-[#C6899E] text-[#4A2233] rounded-full px-8 py-3.5 text-sm uppercase tracking-[0.15em] hover:bg-[#B4718C] transition-colors disabled:opacity-40">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {t("send")}
          </button>
        </form>
      </div>
    </div>
  );
}
